import PraemienData from '@/components/praemien/praemiengewerbe';
import Branchen from "@/store/config/gewerbeBranchen";
import { adjustPraemie } from '../helper/praemienHelper';
import { praemienService } from '../helper/httpService';

function getSinglePrice(praemien, sb, produkt, mitarbeiter, fahrzeuge, immobilien, wohnungen, laufzeit, zahlweise, base) {
  let price = 0;
  switch(produkt) {
    case 'VERKA': case 'VERKB': case 'VERKC':
      price = getVerkehrPrice(praemien, sb.gewerbe, fahrzeuge, produkt.substr(4));
      break;
    case 'FIRM':
      price = getFirmaPrice(praemien, sb.gewerbe, getAnzahlMitarbeiter(mitarbeiter));
      break;
    case 'MIET': case 'MIETZ':
      if(!immobilien){
        return 0;
      } else {
        // adjustPraemie before adding all Immobilien-Deckungen
        return immobilien.reduce((sum, immobilie) => {
          const p = getImmobiliePrice(praemien, sb.gewerbe, immobilie);
          return (!base) ? sum + adjustPraemie(p, zahlweise, laufzeit) : sum + p;
        }, 0);
      }
    case (/^SPEZ-*/.test(produkt) ? produkt : ''): {
      const prod = produkt.split('-')[1];
      if (prod === 'PRIVVM') {
        price = getKompexZusatzWohnungenPrice(praemien, sb.privat, wohnungen);
      } else if (/^PRIV*/.test(prod)) {
        price = getKompexZusatzPrice(praemien, sb.privat, prod);
      } else {
        // special case KOMPEX: SPEZ-PBV+MIET are added before adjustments for Laufzeit etc are done
        const prods = prod.split('+');
        price = prods.map(p => getKompexPrice(praemien, sb.gewerbe, sb.privat, p, getAnzahlMitarbeiter(mitarbeiter)))
          .reduce((sum, value) => sum + value, 0);
      }
      break;
    }
    default:
      console.log(`Price calculation failed: Invalid product key ${produkt}`);
      return 0;
  }
  if (!base) price = adjustPraemie(price, zahlweise, laufzeit);
  return isNaN(price) ? 0 : price;
}

function getAnzahlMitarbeiter(mitarbeiter) {
  let sum = 0;
  Object.values(mitarbeiter).forEach(m => {
    sum += (+m.anzahl) * m.faktor;
  });
  sum = Math.floor(sum + 0.49);
  return sum;
}

function getFirmaPrice(praemien, sb, anzMitarbeiter) {
  const ranges = praemien['FIRM'].RANGE;
  const range = ranges.find(r => anzMitarbeiter >= +r['@RMIN'] && anzMitarbeiter <= +r['@RMAX']);
  let price;
  try {
    price = toNumber(range[`SB${sb}`]);
  } catch (e) {
    console.log(`Price calculation failed for FIRM SB${sb} RANGE ${anzMitarbeiter}`);
    price = 0;
  }
  return price;
}

function getVerkehrPrice(praemien, sb, fahrzeuge, flotte) {
  let a = 0, b = 0, c = 0;
  Object.values(fahrzeuge).forEach(f => {
    switch(f.flotte){
      case 'A':
        a += +f.anzahl;
        break;
      case 'B':
        b += +f.anzahl;
        break;
      case 'C':
        c += +f.anzahl;
        break;
    }
  });
  switch(flotte){
    case 'A':
      return a > 0 ? getFlotteABPrice(praemien, sb, 'A', a) : 0;
    case 'B':
      return b > 0 ? getFlotteABPrice(praemien, sb, 'B', b) : 0;
    case 'C':
      return c > 0 ? getFlotteCPrice(praemien, sb, c, a + b) : 0;
    default:
      console.log(`Price calculation failed for VERK FLOTTE ${flotte}: invalid Flotte`);
      return 0;
  }
}

function getFlotteABPrice(praemien, sb, flotte, anzahl) {
  const ranges = praemien[`VERK`][`GWVERK${flotte}`].RANGE;
  const plus2 = praemien[`VERK`][`GWVERK${flotte}`].plus2;
  const range = ranges.find(r => anzahl >= +r['@RMIN'] && anzahl <= +r['@RMAX']);
  let price;
  try {
    if (range) {
      price = toNumber(range[`SB${sb}`]);
    } else {
      const maxRange = ranges.reduce((a, b) => +(a['@RMAX']) > +(b['@RMAX']) ? a : b);
      price = toNumber(maxRange[`SB${sb}`]);
      const diff = anzahl - (+maxRange['@RMAX']);
      price += Math.ceil(diff / 2) * toNumber(plus2[`SB${sb}`]);
    }
  } catch (e) {
    console.log(`Price calculation failed for GWVERK${flotte} SB${sb} RANGE ${anzahl}`);
    price = 0;
  }
  return price;
}

function getFlotteCPrice(praemien, sb, anzahl, anzahlAB) {
  if ( anzahlAB > 4) {
    return 0; //Ab dem fünften Fahrzeug im Flottentarif A und B sind Anhänger <b>beitragsfrei</b>
  }
  const range = praemien[`VERK`][`GWVERKC`].RANGE;
  let price;
  try {
    price = toNumber(range[`SB${sb}`]) * toNumber(range[`@multi`]) * anzahl;
  } catch (e) {
    console.log(`Price calculation failed for GWVERKC SB${sb} RANGE ${anzahl}`);
    price = 0;
  }
  return price;
}

function getImmobiliePrice(praemien, sb, immobilie) {
  switch(immobilie.art) {
    case 'SELBST':
      return getSelbstPreis(praemien, sb, immobilie.value);
    case 'MIET':
    case 'VERMIET':
      return getMietVermietPrice(praemien, sb, immobilie.art, immobilie.value);
    case 'GARAGE':
    case 'UNBEBAUT':
      return getGarageUnbebautPrice(praemien, sb, immobilie.art, immobilie.value);
  }
}

function getSelbstPreis(praemien, sb, qm) {
  const ranges = praemien[`MIET`][`SELBST`].RANGE;
  const plus = praemien[`MIET`][`SELBST`].PLUS;
  const range = ranges.find(r => +qm >= +r['@RMIN'] && +qm <= +r['@RMAX']);
  let price;
  try {
    if (range) {
      price = toNumber(range[`SB${sb}`]);
    } else {
      const maxRange = ranges.reduce((a, b) => +(a['@RMAX']) > +(b['@RMAX']) ? a : b);
      price = toNumber(maxRange[`SB${sb}`]);
      const diff = +qm - (+maxRange['@RMAX']);
      price += Math.ceil(diff / (+plus[`@UNIT`])) * toNumber(plus[`SB${sb}`]);
    }
  } catch (e) {
    console.log(`Price calculation failed for MIET SELBST SB${sb} VALUE ${qm}`);
    price = 0;
  }
  return price;
}

function getMietVermietPrice(praemien, sb, art, value) {
  const range = praemien[`MIET`][art];
  let price;
  try {
    const minimum = toNumber(range[`MIN${sb}`]);
    price =  toNumber(range[`SB${sb}`]) / 100 * +value;
    return minimum > price ? minimum : price;
  } catch (e) {
    console.log(`Price calculation failed for MIET ${art} SB${sb} VALUE ${value}`);
    price = 0;
  }
  return price;
}

function getGarageUnbebautPrice(praemien, sb, art, value) {
  const range = art === 'UNBEBAUT' ? praemien[`MIET`][`UNBEBAUT`].RANGE : praemien[`MIET`][art];
  let price;
  try {
    price =  Math.ceil(+value / (+range['@UNIT'])) * toNumber(range[`SB${sb}`]);
  } catch (e) {
    console.log(`Price calculation failed for MIET ${art} SB${sb} VALUE ${value}`);
    price = 0;
  }
  return price;
}

function getKompexPrice(praemien, sbGewerbe, sbPrivat, produkt, anzMitarbeiter) {
  const ranges = praemien['SPEZ'][produkt];
  const range = ranges.find(r => anzMitarbeiter >= +r['@RMIN'] && anzMitarbeiter <= +r['@RMAX']);
  let price;
  try {
    price = toNumber(range[`SB${sbGewerbe}P${sbPrivat}`]);
  } catch (e) {
    console.log(`Price calculation failed for SPEZ ${produkt} SBGEW${sbGewerbe} SBPRIV${sbPrivat} RANGE ${anzMitarbeiter}`);
    price = 0;
  }
  return price;
}

function getKompexZusatzPrice(praemien, sb, produkt) {
  let range, price;
  if (produkt === 'PRIVCYBER') sb = 150;
  range = praemien['SPEZ'][produkt];
  try {
    price = toNumber(range[`SB${sb}`]);
  } catch (e) {
    console.log(`Price calculation failed for SPEZ ${produkt} SBPRIV${sb}`);
    price = 0;
  }
  return price;
}

function getKompexZusatzWohnungenPrice(praemien, sb, wohnungen) {
  return wohnungen.reduce((sum, wohnung) => sum + getKompexZusatzWohnungPrice(praemien, sb, wohnung), 0);
}

function getKompexZusatzWohnungPrice(praemien, sb, wohnung) {
  let range, price;
  range = praemien['SPEZ'].PRIVVM.find(r => +wohnung.bruttojahresmiete >= +r['@RMIN'] && +wohnung.bruttojahresmiete <= +r['@RMAX']);
  try {
    price = toNumber(range[`SB${sb}`]);
    // price might be expressed in %
    if (price < 10) {
      price = +wohnung.bruttojahresmiete * price / 100;
    }
  } catch (e) {
    console.log(`Price calculation failed for SPEZ PRIVVM SBPRIV${sb} MIETE ${wohnung.bruttojahresmiete}`);
    price = 0;
  }
  return price;
}

function toNumber(str) {
  return +(str.replace(',', '.'));
}

function checkBrancheProdukt(codeBranche, produkt) {
  let branche = Branchen.exclusions.find(b => b.code === codeBranche);
  if (!branche) {
    branche = Branchen.branchen.find(b => b.code === codeBranche);
    if (!branche) {
      console.log(`Branchencheck failed for invalid Branchen-Code ${codeBranche}`);
      return false;
    }
    // no exclusions for this branche
    branche.KEINVERKEHR = 0;
    branche.KEINFIRMA = 0;
    branche.KEINIMMOBILIEN = 0;
    branche.KEINKOMPEX = 0;
    branche.KEINSSR = 0;
  }

  switch(produkt) {
    case 'VERK':
      return !branche.KEINVERKEHR;
    case 'FIRM':
      return !branche.KEINFIRMA;
    case 'MIET':
      return !branche.KEINIMMOBILIEN;
    case (/^SPEZ-*/.test(produkt) ? produkt : ''): {
      const prod = produkt.split('-')[1];
      if (prod === 'SSRG') {
        return !branche.KEINKOMPEX && !branche.KEINSSR;
      } else {
        return !branche.KEINKOMPEX;
      }
    }
    default:
      console.log(`Branchencheck failed for invalid product ${produkt}`);
      return false;
  }
}

function checkBranche(branche, produkt) {
  if (Array.isArray(produkt)) {
    for (let i=0; i < produkt.length; i++) {
      if (!checkBrancheProdukt(branche, produkt[i])) return false;
    }
    return true;
  } else {
    return checkBrancheProdukt(branche, produkt);
  }
}

function checkBranchen(branchen, produkt) {
  for (let i=0; i < branchen.length; i++) {
    if (!checkBranche(branchen[i], produkt)) return false;
  }
  return true;
}

const getters = {
  gewerbePrice: state => (sb, produkt, ...params) => {
    if (!state.praemien) return 0;
    if (Array.isArray(produkt)) {
      return produkt.reduce((sum, value) => sum + getSinglePrice(state.praemien, sb, value, ...params), 0);
    } else {
      return getSinglePrice(state.praemien, sb, produkt, ...params);
    }
  },
  gewerbeProductAvailable: () => (personen, hasMvUnternehmen, produkt) => {
    let firmen = personen.filter(f => !!f.firma);
    if (!hasMvUnternehmen) {
      firmen = firmen.filter(f => !(/^mvu[0-9]*$/.test(f.key)));
    }
    const branchen = firmen.map(f => f.branche.code).filter(code => !!code);
    return checkBranchen(branchen, produkt);
  }
};

const actions = {
  initializePraemienGewerbeData: function (context) {
    praemienService.getGewerbePrice()
      .then(content => {
        context.commit('setPraemienGewerbeData', content);
      })
      .catch( err => {
        console.log(`GET GEWERBEPRICE failed with ${err.status}: ${err.message}`);
        if (process.env.NODE_ENV === 'development') {
          context.commit('setPraemienGewerbeData', PraemienData );
        }
      });
  }
};

const mutations = {
  setPraemienGewerbeData (state, priceobject) {
    state.praemien = priceobject.praemien;
  }
};

const state = {
  praemien: null
};

export default {
  state,
  getters,
  actions,
  mutations
};
